import { Component, OnInit, ViewEncapsulation, ViewChild, Renderer2, AfterViewInit, Injector, NgZone, signal, ChangeDetectionStrategy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ModalService } from 'src/app/shared/service/modal/modal.service';
import { LineModalTemplateService } from 'src/app/shared/service/modal/components/line-modal-template/line-modal-template.service';
import { LineModalTemplateComponent } from 'src/app/shared/service/modal/components/line-modal-template/line-modal-template.component';
import { GenerateOTPService } from 'src/app/adapters/generateOTP.service';
import { DeleteOTPService } from 'src/app/adapters/deleteOTP.service';
import { VerifyOTPService } from 'src/app/adapters/verifyOTP.service';
import { FormPreRegistrationService } from '../services/form-pre-registration.service';
import { LineNotificationService } from '../services/line-notification.service';
import { encryptData, decryptData, getLiffNumber } from '../../../core/utilities';
import { ResponseCodePreRegistration } from '../../line/models/pre-registration.model';
import { ConcentService } from '../services/concent.service';
import { defer, from, Observable, of } from 'rxjs';
import { LineStateActionService } from '../statemanagement/line-state-action.service';
import { FormRegistrationService } from '../services/form-registration.service';
import { FormVerifyCustomerService } from '../services/form-verify-customer.service';
import { ResponseCodeRegistration } from '../models/registration.model';
import { LoaderService } from '../services/loader.service';
import { OtpService } from '../services/otp.service';
import { TermsAndConditionService } from '../services/terms-and-condition.service';
import { ResponseStatus } from '../models/termAndCondition.model';
import { TelemedStateActionService } from "../statemanagement/telemed-state-action.service"
import { FormAdditionalServiceRegistrationService } from '../services/form-additional-service-registration.service';
import { TelemedService } from '../services/telemed.service';
import { ResponseStatusLine } from '../models/termAndConditionLine.model';
import { CommonService } from '../services/common.service'
import { BaseComponents } from '../../../base.component';
import { ReferenceService } from 'src/app/services/reference.service';
import { GetMaskingService } from 'src/app/adapters/getMasking.service';
import { catchError, map, switchMap, tap } from 'rxjs/operators';

declare var liff: any;
declare var window: any;
@Component({
    selector: 'app-confirm-otp',
    templateUrl: './confirm-otp.component.html',
    styleUrls: ['./confirm-otp.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConfirmOtpComponent extends BaseComponents implements OnInit, AfterViewInit {
    otp: string = '';
    invalidOTP = signal<boolean>(false);
    isDisabledBtnConfirmOTP = true;
    countOTP = 0;
    countOTPMax = 0;
    countResnedOTP = 0;
    otpRef = signal<string>('');
    otpToken: string = '';
    otpLock = false;
    countdown = signal<string>('00:00');
    liffData: any;
    comCode: string = '';
    ref: string = "";
    liff_motor: string = "";
    flow: number | null = null;
    classify_insure: number | null = null;
    // Mockup OTP Mobile
    model = signal<any>({
        form: {
            mobile: '',
            chanelId: '',
            userId: '',
            id_card: '',
            phone_number: '',
            firstname: '',
            lastname: '',
            chanelLiffNumber: ''
        }
    })
    state: any = {
        text: 'pre-register',
        value: '1'
    };
    // 5 = SMS, 6=QR
    btnSubmitGroup: any = {
        "6": "ยืนยันและเพิ่มเพื่อน"
    }
    btnSubmitText = signal<string>("ยืนยัน");
    @ViewChild('ngOtpInput') ngOtpInputRef: any;
    // $concentState: BehaviorSubject<ApiResponse<ConcentUrl>> = new BehaviorSubject(null)
    // concentUrlObservable: Observable<any> = this.$concentState.asObservable()
    mockUpStatus: boolean = false;
    electronic_channel: number | null = null;
    log_session_text: string = "confirm-otp";
    referenceUUID: string | null = null;
    constructor(
        protected injectorObj: Injector,
        private router: Router,
        private route: ActivatedRoute,
        private modalService: ModalService,
        private lineModalService: LineModalTemplateService,
        private generateOTPService: GenerateOTPService,
        private deleteOTPService: DeleteOTPService,
        private verifyOTPService: VerifyOTPService,
        private formPreRegistrationService: FormPreRegistrationService,
        private concentService: ConcentService,
        private lineStateAction: LineStateActionService,
        private lineActionService: LineStateActionService,
        private formRegistrationService: FormRegistrationService,
        private loaderService: LoaderService,
        private lineNotificationService: LineNotificationService,
        private otpService: OtpService,
        private renderer: Renderer2,
        private formVerifyCustomerService: FormVerifyCustomerService,
        private termsAndConditionService: TermsAndConditionService,
        private telemedStateActionService: TelemedStateActionService,
        private formAdditionalServiceRegistration: FormAdditionalServiceRegistrationService,
        private telemedService: TelemedService,
        private commonService:CommonService,
        private referenceService:ReferenceService,
        public getMaskingService:GetMaskingService,
        private zone: NgZone
    ) {
        super(injectorObj); 
        
     }

    ngOnInit() {
        const funcName = 'ngOnInit';
        this.referenceUUID = this.referenceService.getReferenceUUID();
        this.log_session_text = `confirm-otp referenceUUID:[${this.referenceUUID}]`
        this.logger.info(`${this.log_session_text} ${funcName} apiGetCommonConfig start`);
        this.commonService.apiGetCommonConfig({ description: null,id:177 }).subscribe(
            (response) => {
                this.mockUpStatus = response?.data?.value == "Y" ? true : false
                this.logger.info(`${this.log_session_text} apiGetCommonConfig mockupStatus:${this.mockUpStatus}`);
            
                // Mockup OTP Ref
                this.otpRef.set('');
                this.generateOTPService.getCountdown().subscribe(countdown => {
                    this.countdown.set('' + countdown)
                    if (this.countdown() == '00:00' || this.countdown() == '') {
                        this.otpLock = false;
                    }
                    //console.log('Countdown SendOTP:', 'c' + countdown, this.countResnedOTP)
                });

                this.route.queryParams.subscribe(async params => {
                    this.logger.info(`${this.log_session_text} generateOTPService params:${JSON.stringify(params)}`);
                    let receive = params['params'];
                    this.logger.info(`${this.log_session_text} generateOTPService receive:${receive}`);
                    receive = this.decryptData(receive);
                    this.logger.info(`${this.log_session_text} generateOTPService receive decryptData:${receive}`);
                    const current = structuredClone(this.model());
                    current.form.id_card = receive.idcard;
                    current.form.chanelId = receive.chanelId;
                    current.form.firstname = receive.firstName;
                    current.form.lastname = receive.lastName;
                    current.form.phone_number = receive.mobile;
                    current.form.userId = receive.userId;
                    current.form.chanelLiffNumber = receive.chanelLiffNumber;
                    this.model.set(current);
                    this.comCode = receive.comCode;
                    this.ref = receive.ref
                    this.liff_motor = receive.liff_motor
                    this.flow = receive.flow
                    this.classify_insure = receive.classify_insure
                    const log_idcard = this.getMaskingService.maskingData(receive.idcard)
                    const log_firstname = this.getMaskingService.maskingData(receive.firstName)
                    const log_lastname = this.getMaskingService.maskingData(receive.lastName)
                    const log_phone_number = this.getMaskingService.maskingData(receive.mobile)
                    this.logger.info(`${this.log_session_text} ${funcName} receive idcard:${log_idcard} firstname:${log_firstname} lastname:${log_lastname} phone_number:${log_phone_number} ref:${this.ref} liff_motor:${this.liff_motor} flow:${this.flow} classify_insure:${this.classify_insure}`);
                    if (receive.more) {
                        this.logger.info(`${this.log_session_text} ${funcName} receive more start`);
                        this.state.text = "update";
                        this.state.value = receive.more.update_channel_identity_flag;
                    } else if (receive.notmatch) {
                        this.logger.info(`${this.log_session_text} ${funcName} receive notmatch`);
                        this.state.text = "notmatch";
                    } else {
                        this.logger.info(`${this.log_session_text} ${funcName} receive else start state value`);
                        this.state.value = receive.update_channel_identity_flag;
                    }

                    if (this.mockUpStatus) {
                        this.otpRef.set("mockup")
                    } else {
                        this.logger.info(`${this.log_session_text} ${funcName} generateOTP start`);
                        this.generateOTP().subscribe()
                    }
                });

                try {
                    this.liffData = liff;
                } catch (err) {

                }
                this.lineActionService.observableIdentity.subscribe(
                    result => {
                        console.log('result of observable', result);
                    }
                )
                const channel = this.lineStateAction.channelStateInfo;

                this.electronic_channel = channel?.electronic_channel ?? null;
                this.logger.info(`${this.log_session_text} ${funcName} electronic_channel:${this.electronic_channel} and initData start`);
                this.initData();
            },
            (error) => {
                this.logger.error(`${this.log_session_text} error sendEmailService => ${error?.message}`);
            }
        )
    }

    ngAfterViewInit(): void {
        // console.log('copy here1');
        // if (this.ngOtpInputRef != null) {
        //     console.log('copy here2');
        //   this.renderer.listen(this.ngOtpInputRef.nativeElement, 'paste', (event) => {
        //     console.log('copy here');
        //   });
        // }
    }

    initData() {
        const identity = this.lineStateAction.identityStateInfo;
        const channel = this.lineStateAction.channelStateInfo;
        this.model.update(v=> ({
            ...v,
            form: {
                ...v.form,
                mobile : identity.phone_number
            }
        }))
        this.setButton(channel?.subChannel ?? "");
    }

    decryptData(re_data: any) {
        if (re_data != "" && re_data != null) {
            let result = JSON.parse(
                decodeURIComponent(
                    Array.prototype.map.call(
                        atob(decryptData(re_data)), function (c) {
                            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
                        }).join('')
                )
            )
            return result;
        }
    }

    onOtpChange(otp: string) {
        console.log('otp:', otp);
        const funcName = 'onOtpChange';
        this.logger.info(`${this.log_session_text} ${funcName} otp:${this.getMaskingService.maskingData(otp)}`);
        if (this.otp != otp && otp?.trim()?.length == 6) {
            console.log('paste data : ' + otp);
            this.logger.info(`${this.log_session_text} ${funcName} otp:${this.getMaskingService.maskingData(otp)} length == 6`);
            this.ngOtpInputRef.setValue(event);
        }
        this.otp = otp;
        if (this.otp?.toString()?.length === 6) {
            this.isDisabledBtnConfirmOTP = false;
            this.logger.info(`${this.log_session_text} ${funcName} otp:${this.getMaskingService.maskingData(otp)} isDisabledBtnConfirmOTP:false`);

        } else {
            this.isDisabledBtnConfirmOTP = true;
            this.logger.info(`${this.log_session_text} ${funcName} otp:${this.getMaskingService.maskingData(otp)} isDisabledBtnConfirmOTP:true`);

        }
    }

    checkDisabled() {
        const funcName = 'checkDisabled';
        this.logger.info(`${this.log_session_text} ${funcName} start`);
        this.logger.info(`${this.log_session_text} ${funcName} otpRef:${this.getMaskingService.maskingData(this.otpRef())}`);
        this.logger.info(`${this.log_session_text} ${funcName} otp:${this.getMaskingService.maskingData(this.otp)}`);
        this.logger.info(`${this.log_session_text} ${funcName} isDisabledBtnConfirmOTP:${this.isDisabledBtnConfirmOTP}`);        
        this.logger.info(`${this.log_session_text} ${funcName} otpLock:${this.otpLock}`);
        let checkValue = (this.otpRef() != '' && ('' + this.otp).length == 6 && (this.isDisabledBtnConfirmOTP || this.otpLock == false)) ? false : true
        //console.log('check',{otpRef:this.otpRef,otpLength:(''+this.otp).length,otp:this.otp,isDisabledBtnConfirmOTP:this.isDisabledBtnConfirmOTP,otpLock:this.otpLock,checkValue:checkValue})
        if(this.mockUpStatus==false){            
            return checkValue;
        }else{           
            return false
        }
    }

    async onSubmit() {
        this.loaderService.opendLoader();
        const funcName = 'onSubmit';
        this.logger.info(`${this.log_session_text} ${funcName} start`);
        let verifyOTP:any = {status:false}
        if(this.mockUpStatus){
            verifyOTP.status = true
            this.logger.info(`${this.log_session_text} ${funcName} verifyOTP status true`);
        }else{
            this.logger.info(`${this.log_session_text} ${funcName} verifyOTP start`);
            verifyOTP = await this.verifyOTP(this.otpToken, this.otp);
            this.logger.info(`${this.log_session_text} ${funcName} verifyOTP result:${JSON.stringify(verifyOTP)}`);
        }
        
        this.logger.info(`${this.log_session_text} ${funcName} verifyOTP status ${verifyOTP?.status}`);
        // Mockup use case error with otp number 999999
        if (verifyOTP.status == false) {
            this.logger.info(`${this.log_session_text} ${funcName} verifyOTP status false start`);
            this.countOTP++;
            this.countOTPMax++;
            this.invalidOTP.set(true);

            // Check OTP incorrect 3 times per reference to lock. Can be resend OTP.
            if (this.countOTP === 3) {
                this.logger.info(`${this.log_session_text} ${funcName} verifyOTP countOTP === 3`);
                this.otpLock = true;
            }

            if (this.countOTPMax === 9) {
                this.otpLock = true;
                this.logger.info(`${this.log_session_text} ${funcName} verifyOTP countOTPMax === 9`);
                this.modalService
                    .open(LineModalTemplateComponent, this.lineModalService.setModalConfig('alert', 'ขออภัย', ['คุณกรอกรหัส OTP ไม่ถูกต้อง', 'เกินจำนวนที่กำหนด', 'กรุณาสมัครใหม่ ในอีก [setCountdown] นาที'], '/assets/images/icon/icon-alert.svg'))
                    .onResult().subscribe(
                        closed => console.log('closed', closed),
                        dismissed => console.log('dismissed', dismissed),
                        () => console.log('completed')
                    );
            } else {
                this.otpLock = false;
                this.logger.info(`${this.log_session_text} ${funcName} verifyOTP countOTPMax !== 9`);
                this.modalService
                    .open(LineModalTemplateComponent, this.lineModalService.setModalConfig('alert', 'ขออภัย', [verifyOTP.msg], '/assets/images/icon/icon-alert.svg'))
                    .onResult().subscribe(
                        closed => console.log('closed', closed),
                        dismissed => console.log('dismissed', dismissed),
                        () => console.log('completed')
                    );
            }
            this.loaderService.closeLoader();
        } else {
            // register new user
            const customer = this.lineStateAction.customerStateInfo;
            const identity = this.lineStateAction.identityStateInfo;
            const channel = this.lineStateAction.channelStateInfo;
            // console.log(identity, channel, customer);
            const payload: any = {
                ...customer,
                ...identity,
                ...channel,
                update_channel_identity_flag: this.state.value
            };
            //addlog
            this.logger.info(`${this.log_session_text} ${funcName} state:${JSON.stringify(this.state)}`);
            this.logger.info(`${this.log_session_text} ${funcName} state.text:${this.state.text}`);
            if (this.state.text == 'update') {
                this.logger.info(`${this.log_session_text} ${funcName} state update and flow register start`);
                payload.update_channel_identity_flag = this.state.value;
                await this.register(payload);
                this.logger.info(`${this.log_session_text} ${funcName} additionalServiceRegistrationTelemed start`);
                const responseAdditional = await this.additionalServiceRegistrationTelemed(payload, 1).then(res => { return res });
                if (!responseAdditional) {
                    this.logger.info(`${this.log_session_text} ${funcName} responseAdditional not have response goto page completed status fail and alert error`);
                    alert('เกิดข้อผิดพลาด บันทึกบริการเสริมไม่สำเร็จ(1)');
                    return await this.router.navigate(['../completed'], { relativeTo: this.route, queryParams: { status: 'fail' } });
                }
            } else if (this.state.text == 'pre-register') {
                this.logger.info(`${this.log_session_text} ${funcName} state pre-register`);
                payload.ref_channel_no = (+getLiffNumber(channel.comCode));
                this.logger.info(`${this.log_session_text} ${funcName} state pre-register additionalServiceRegistrationTelemed start`);
                const responseAdditional = await this.additionalServiceRegistrationTelemed(payload, 2).then(res => { return res });
                this.logger.info(`${this.log_session_text} ${funcName} state pre-register additionalServiceRegistrationTelemed end result:${responseAdditional}`);
                if (!responseAdditional) {
                    this.logger.info(`${this.log_session_text} ${funcName} state pre-register additionalServiceRegistrationTelemed end result false goto page completed status fail and alert error`);
                    alert('เกิดข้อผิดพลาด บันทึกบริการเสริมไม่สำเร็จ(2)');
                    return await this.router.navigate(['../completed'], { relativeTo: this.route, queryParams: { status: 'fail' } });
                }
                this.logger.info(`${this.log_session_text} ${funcName} state pre-register call apiPreRegistration start`);

                this.formPreRegistrationService.apiPreRegistration(payload).subscribe(
                    async (result: any) => {
                        this.logger.info(`${this.log_session_text} ${funcName} state pre-register call apiPreRegistration result:${JSON.stringify(result)}`);
                        if (!result) {
                            this.logger.info(`${this.log_session_text} ${funcName} state pre-register call apiPreRegistration not have result`);
                            this.loaderService.closeLoader();
                            return
                        }
                        switch (result.state_code) {
                            case (ResponseCodePreRegistration.NOT_CREATE): {
                                this.logger.info(`${this.log_session_text} ${funcName} state pre-register call apiPreRegistration not create`);
                                this.loaderService.closeLoader();
                                break;
                            }
                            case (ResponseCodePreRegistration.SUCCESS): {
                                this.logger.info(`${this.log_session_text} ${funcName} state pre-register call apiPreRegistration success`);
                                this.logger.info(`${this.log_session_text} ${funcName} state pre-register call apiPreRegistration channel.termsAndCondition.action:${channel?.termsAndCondition?.action}`);
                                if (channel && channel.termsAndCondition && channel.termsAndCondition.action == "accept") {
                                    //brended
                                    this.logger.info(`${this.log_session_text} ${funcName} state pre-register call apiPreRegistration check termsAndCondition accept`);
                                    this.logger.info(`${this.log_session_text} ${funcName} state pre-register call apiPreRegistration channel.termsAndConditionLine.action:${channel?.termsAndConditionLine?.action}`);
                                    if (channel && channel.termsAndConditionLine && channel.termsAndConditionLine.action == "accept") {
                                        this.logger.info(`${this.log_session_text} state pre-register call apiPreRegistration callTermAndConditionLine start`);
                                        await this.callTermAndConditionLine(null);
                                        this.logger.info(`${this.log_session_text} state pre-register call apiPreRegistration callTermAndConditionLine end`);
                                    }
                                    this.logger.info(`${this.log_session_text} state pre-register call apiPreRegistration callTermAndCondition start`);
                                    await this.callTermAndCondition(null);
                                    this.logger.info(`${this.log_session_text} state pre-register call apiPreRegistration callTermAndCondition end`);
                                } else {
                                    //tiscoinsure
                                    this.logger.info(`${this.log_session_text} state pre-register call apiPreRegistration case else channel.termsAndConditionLine.action ${channel?.termsAndConditionLine?.action}`);
                                    if (channel && channel.termsAndConditionLine && channel.termsAndConditionLine.action == "accept") {
                                        this.logger.info(`${this.log_session_text} state pre-register call apiPreRegistration case else callTermAndConditionLine start`);
                                        await this.callTermAndConditionLine(null);
                                        this.logger.info(`${this.log_session_text} state pre-register call apiPreRegistration case else callTermAndConditionLine end`);
                                    }
                                    this.logger.info(`${this.log_session_text} state pre-register call apiPreRegistration case else call consent start`);
                                    this.callConcent();
                                    this.logger.info(`${this.log_session_text} state pre-register call apiPreRegistration case else call consent end`);
                                }
                                break;
                            }
                        }
                    }
                );
            } else if (this.state.text == 'notmatch') {
                this.logger.info(`${this.log_session_text} state notmatch start`);
                payload.ref_channel_no = (+getLiffNumber(channel.comCode));
                this.logger.info(`${this.log_session_text} state notmatch call apiUpdatePhoneNotMatch start`);
                this.formVerifyCustomerService.apiUpdatePhoneNotMatch(payload).subscribe(
                    async result => {
                        this.logger.info(`${this.log_session_text} state notmatch call apiUpdatePhoneNotMatch response:${result?.state_code}`);
                        const json_res = JSON.stringify(result);
                        console.log(json_res);
                        // console.log(identity, channel, customer);
                        if (result.state_code == 'L20002') {
                            const channel = {
                                ...this.lineStateAction.channelStateInfo,
                                template_id: '124_19'
                            };
                            let payload = {
                                ...channel,
                                "template_ref": "AFTER_UPDATE_PHONE_NUMBER",
                                "template_parameter": {}
                              }
                            this.logger.info(`${this.log_session_text} state notmatch call apiUpdatePhoneNotMatch case L20002 and sendNotification start`);
                            this.lineNotificationService.sendNotificationWithTemplate(payload).subscribe(
                                (result_line: any) => {
                                    this.logger.info(`${this.log_session_text} state notmatch call apiUpdatePhoneNotMatch case L20002 result:${JSON.stringify(result_line)}`);
                                    console.log(result_line);
                                }
                            );
                            this.loaderService.closeLoader();
                            this.logger.info(`${this.log_session_text} state notmatch channel.registerFlow:${channel?.registerFlow}`);
                            if (channel.registerFlow == "telemed") {
                                this.logger.info(`${this.log_session_text} state notmatch flow telemed goto page dazFormComplete`);
                                return this.router.navigate(["./dazFormComplete"], { relativeTo: this.route });
                            } else {
                                this.logger.info(`${this.log_session_text} state notmatch flow other goto page completed`);
                                return this.router.navigate(['../completed'], { relativeTo: this.route, queryParams: { ref: this.ref, liff_motor: this.liff_motor, flow: this.flow, classify_insure: this.classify_insure } });
                            }
                        } else {
                            this.loaderService.closeLoader();
                            // this.lineStateAction.otpCount++;
                            this.logger.info(`${this.log_session_text} state notmatch case not in L20002 goto page completed status fail`);
                            return this.router.navigate(['../completed'], { relativeTo: this.route, queryParams: { status: 'fail' } });
                        }
                    }
                )
            }
        }
    }

    additionalServiceRegistrationTelemed(payload:any , registerType:number): Promise<boolean> {
        let self=this;
        return new Promise((resolve, reject) => {
            try {
                self.logger.info(`${self.log_session_text} additionalServiceRegistrationTelemed start`);
                const channel = self.lineActionService.channelStateInfo;
                const { phone_number, electronic_channel, channel_identity } = payload
                if (channel.registerFlow == "telemed") {
                    let body:any = {
                        "registration_reference": phone_number,
                        "electronic_channel": electronic_channel
                    }
                    // register type 1 = register already
                    if (registerType == 1) {
                        self.logger.info(`${self.log_session_text} additionalServiceRegistrationTelemed registerType == 1`);
                        body['channel_identity'] = channel_identity;
                    }
                    const log_body = {
                        ...body,
                        registration_reference : self.getMaskingService.maskingData(body.registration_reference)
                    }
                    self.logger.info(`${self.log_session_text} additionalServiceRegistrationTelemed call apiInsert start body:${JSON.stringify(log_body)}`);
                    self.formAdditionalServiceRegistration.apiInsert(body).subscribe(response => {
                        self.logger.info(`${self.log_session_text} additionalServiceRegistrationTelemed call apiInsert result:${response?.state_code}`);
                        if (response && response.state_code != "S20000") {
                            self.logger.info(`${self.log_session_text} additionalServiceRegistrationTelemed call apiInsert resolve false`);
                            return resolve(false);
                        }
                    });
                }
                self.logger.info(`${self.log_session_text} additionalServiceRegistrationTelemed resolve true`);
                return resolve(true);
            }
            catch (error) {
                self.logger.error(`${self.log_session_text} additionalServiceRegistrationTelemed error:${error}`);
                console.log('fatal error addition service regis')
                resolve(false);
            }
        })

    }


    async register(payload:any): Promise<boolean> {
        let self=this;
        return new Promise((resolve, reject) => {
            self.logger.info(`${self.log_session_text} verifyOTP register call apiRegistration start`);
            self.formRegistrationService.apiRegistration(payload).subscribe(
                (result:any) => {
                    resolve(false);
                    const log_result = result ? JSON.stringify(result) : null;
                    self.logger.info(`${self.log_session_text} verifyOTP call apiRegistration result:${log_result}`);

                    if (!result) {
                        self.logger.info(`${self.log_session_text} verifyOTP call apiRegistration result not have value`);
                        self.loaderService.closeLoader();
                        self.router.navigate(['../completed'], { relativeTo: self.route, queryParams: { status: 'fail', code: 'E00001' } });
                    }
                    resolve(true);
                    const json_res = JSON.stringify(result);
                    console.log(json_res);
                    self.logger.info(`${self.log_session_text} verifyOTP call apiRegistration result status_code:${result?.state_code}`);
                    switch (result.state_code) {
                        case ResponseCodeRegistration.SUCCESS: {
                            self.logger.info(`${self.log_session_text} verifyOTP call apiRegistration result response_code:SUCCESS`);

                            const channel = self.lineStateAction.channelStateInfo;
                            self.logger.info(`${self.log_session_text} verifyOTP call apiRegistration channel.termsAndCondition.action:${channel?.termsAndCondition?.action}`);
                            if (channel && channel.termsAndCondition && channel.termsAndCondition.action == "accept") {
                                //branded
                                self.logger.info(`${self.log_session_text} verifyOTP call apiRegistration channel.termsAndConditionLine.action:${channel?.termsAndConditionLine?.action}`);
                                if (channel && channel.termsAndConditionLine && channel.termsAndConditionLine.action == "accept") {
                                    self.logger.info(`${self.log_session_text} verifyOTP call apiRegistration callTermAndConditionLine start`);
                                    self.callTermAndConditionLine(result["_1"]);
                                    self.logger.info(`${self.log_session_text} verifyOTP call apiRegistration callTermAndConditionLine end`);
                                }
                                self.logger.info(`${self.log_session_text} verifyOTP call apiRegistration callTermAndCondition start`);
                                self.callTermAndCondition(result["_1"]);
                                self.logger.info(`${self.log_session_text} verifyOTP call apiRegistration callTermAndCondition end`);
                            } else {
                                //tiscoinsure
                                self.logger.info(`${self.log_session_text} verifyOTP call apiRegistration case else channel.termsAndConditionLine.action:${channel?.termsAndConditionLine?.action}`);

                                if (channel && channel.termsAndConditionLine && channel.termsAndConditionLine.action == "accept") {
                                    self.logger.info(`${self.log_session_text} verifyOTP call apiRegistration case else callTermAndConditionLine start`);
                                    self.callTermAndConditionLine(result["_1"]);
                                    self.logger.info(`${self.log_session_text} verifyOTP call apiRegistration case else callTermAndConditionLine end`);
                                }
                                self.logger.info(`${self.log_session_text} verifyOTP call apiRegistration call consent start`);
                                self.callConcent();
                                self.logger.info(`${self.log_session_text} verifyOTP call apiRegistration call consent end`);
                            }
                            break;
                        }
                        default: {
                            self.loaderService.closeLoader();
                            self.logger.info(`${self.log_session_text} verifyOTP call apiRegistration flow default goto page completed status fail`);
                            self.router.navigate(['../completed'], { relativeTo: self.route, queryParams: { status: 'fail', code: result.state_code } });
                        }
                            break;
                    }
                    self.loaderService.closeLoader();
                }
            )
        })
    }

    async callTermAndCondition(identityUcid:string|null) {
        const customer = this.lineStateAction.customerStateInfo;
        const identity = this.lineStateAction.identityStateInfo;
        const channel = this.lineStateAction.channelStateInfo;
        let body = {
            "identity_ucid": identityUcid,
            "comcode": channel.comCode,
            "id_no": identity.id_card,
            "first_name": customer.firstname,
            "last_name": customer.lastname,
            // "channel_identity": channel.channel_identity,
            "electronic_channel": channel.electronic_channel,
            "application_channel_reference": channel.application_channel_reference,
            "app_no": channel.appNo,
            "term_and_condition_id": (channel.termsAndCondition ? channel.termsAndCondition.termConditionId : null)
        }
        this.termsAndConditionService.apiCreateOrUpdateTermsAndCondition(body).subscribe(result => {
            if (result?.response_code == "40000") {
                console.log(["create or update success: ", result]);
                if(channel.termsAndCondition) {
                    channel.termsAndCondition.status = ResponseStatus.COMPLETED;
                }
                this.lineStateAction.observableChannel.subscribe();
                this.callConcent();
            } else {
                this.router.navigate(['../completed'], { relativeTo: this.route, queryParams: { status: 'fail', code: 'E00004' } });
            }
        })
    }

    async callTermAndConditionLine(identityUcid:string|null) {
        const customer = this.lineStateAction.customerStateInfo;
        const identity = this.lineStateAction.identityStateInfo;
        const channel = this.lineStateAction.channelStateInfo;
        let body = {
            "identity_ucid": identityUcid,
            "comcode": channel.comCode,
            "id_no": identity.id_card,
            "first_name": customer.firstname,
            "last_name": customer.lastname,
            // "channel_identity": channel.channel_identity,
            "electronic_channel": channel.electronic_channel,
            "application_channel_reference": channel.application_channel_reference,
            "app_no": channel.appNo,
            "term_and_condition_id": (channel.termsAndConditionLine ? channel.termsAndConditionLine.termConditionId : null)
        }
        const log_body = {
            ...body,
            id_no : this.getMaskingService.maskingData(body.id_no),
            first_name : this.getMaskingService.maskingData(body.first_name),
            last_name : this.getMaskingService.maskingData(body.last_name)
        }
        // console.log('apiCreateOrUpdateTermsAndCondition line start')
        this.logger.info(`${this.log_session_text} callTermAndConditionLine apiCreateOrUpdateTermsAndCondition start body:${JSON.stringify(log_body)}`);
        this.termsAndConditionService.apiCreateOrUpdateTermsAndCondition(body).subscribe(result => {
            this.logger.info(`${this.log_session_text} callTermAndConditionLine apiCreateOrUpdateTermsAndCondition response:${result?.response_code}`);
            if (result?.response_code == "40000") {
                this.logger.info(`${this.log_session_text} callTermAndConditionLine apiCreateOrUpdateTermsAndCondition create or update line success`);
                console.log(["create_or_update_success_line: ", result]);
                if(channel.termsAndConditionLine) {
                    channel.termsAndConditionLine.status = ResponseStatusLine.COMPLETED;
                }
                this.lineStateAction.observableChannel.subscribe();              
            } else {
                this.logger.info(`${this.log_session_text} callTermAndConditionLine apiCreateOrUpdateTermsAndCondition create or update line fail goto page completed status fail`);
                this.router.navigate(['../completed'], { relativeTo: this.route, queryParams: { status: 'fail', code: 'E00004' } });
            }
        })
    }

    callConcent() {
        const customer = this.lineStateAction.customerStateInfo;
        const identity = this.lineStateAction.identityStateInfo;
        const channel = this.lineStateAction.channelStateInfo;
        this.logger.info(`${this.log_session_text} callConcent channel.registerFlow:${channel?.registerFlow}`);
        this.logger.info(`${this.log_session_text} callConcent channel.comCode:${channel?.comCode}`);
        if ((channel?.registerFlow?.toLowerCase() == "short" && channel.comCode == "insure") || channel?.registerFlow?.toLowerCase() != "short") {
            let cust_type = 1;
            this.logger.info(`${this.log_session_text} callConcent cust_type == 1`);
            this.logger.info(`${this.log_session_text} callConcent this.state.text:${this.state.text}`);
            if (this.state.text == 'pre-register') {
                cust_type = 2;
                this.logger.info(`${this.log_session_text} callConcent case pre-register cust_type == 2`);
            }


            const session_ref = Date.now()
            let body = {
                "comcode": channel.comCode,
                "cust_type": cust_type,
                "id_no": identity.id_card,
                "first_name": customer.firstname,
                "last_name": customer.lastname,
                "line_channel_id": channel.application_channel_reference,
                // "line_user_id": channel.channel_identity,
                "electronic_channel": channel.electronic_channel,
                "liff_id": channel.liffUrl,
                "session_ref": session_ref || undefined,
                "branded": channel.branded,
                "flow_name": channel.registerFlow
            }
            const log_body = {
                ...body,
                id_no : this.getMaskingService.maskingData(body.id_no),
                first_name : this.getMaskingService.maskingData(body.first_name),
                last_name : this.getMaskingService.maskingData(body.last_name)
            }
            this.logger.info(`${this.log_session_text} callConcent apiConcentUrl start body:${JSON.stringify(log_body)}`);
            if (channel?.registerFlow?.toLowerCase() == "short") {
                body.liff_id = channel.oaMessageUrl;
                delete body.session_ref;
                this.logger.info(`${this.log_session_text} callConcent case short flow`);
            } else {
                this.logger.info(`${this.log_session_text} callConcent case not short flow channel:${JSON.stringify(channel)}`);
                let payload = {
                    ...channel,
                    "template_ref": "END_REGISTER",
                    "template_parameter": {}
                  }
                this.lineNotificationService.sendNotificationWithTemplate(payload).subscribe(
                    (result_line: any) => {
                        this.logger.info(`${this.log_session_text} callConcent sendNotification result:${JSON.stringify(result_line)}`);
                        console.log(result_line);
                    }
                );
            }

            this.concentService.apiConcentUrl(body).subscribe(result => {
                this.loaderService.closeLoader();                
                const log_result = result ? JSON.stringify(result) : null;
                this.logger.info(`${this.log_session_text} callConcent apiConcentUrl result:${log_result}`);
                if (result?.data?.token_url) {
                    this.logger.info(`${this.log_session_text} callConcent apiConcentUrl have token_url and setSessionStorage`);
                    this.setSessionStorage(session_ref);
                    window.location.href = result.data.token_url;
                    return;

                } else if (result?.data) {
                    this.logger.info(`${this.log_session_text} callConcent apiConcentUrl have result_data`);
                    const channel = this.lineStateAction.channelStateInfo;
                    if (channel?.registerFlow?.toLowerCase() == "short") {
                        console.log("case add friend after consent success");
                        this.logger.info(`${this.log_session_text} callConcent apiConcentUrl have result_data case add friend after consent success`);
                        this.redirectToLineAdd()
                    } else {
                        const params = {
                            ref: this.ref, liff_motor: this.liff_motor, flow: this.flow
                        }
                        this.logger.info(`${this.log_session_text} callConcent apiConcentUrl have result_data case not short flow goto page completed`);
                            const query = encryptData(this.b64EncodeUnicode(JSON.stringify(params)));
                            return this.router.navigate(['../completed'], { relativeTo: this.route, queryParams: { params: query } });
                    }
                } else {
                    this.logger.info(`${this.log_session_text} callConcent apiConcentUrl not have result_data goto page completed status fail`);
                    this.router.navigate(['../completed'], { relativeTo: this.route, queryParams: { status: 'fail', code: 'E00006' } });
                }
                console.log('consent result: ', result);
            });
        } else {
            this.logger.info(`${this.log_session_text} callConcent case add friend with out consent`);
            console.log("case add friend with out consent");
            const url = channel.oaMessageUrl;
            console.log("url: " + url);
            this.logger.info(`${this.log_session_text} callConcent case add friend with out consent url:${url}`);
            window.location.href = url;
        }


    }

    async resendOTP() {
        this.logger.info(`${this.log_session_text} resendOTP start`);
        if (this.model().form.mobile == '') {
            this.logger.info(`${this.log_session_text} resendOTP form mobile is null alert error`);
            this.modalService
                .open(LineModalTemplateComponent, this.lineModalService.setModalConfig('alert', 'ขออภัย', ['กรุณากรอกเบอร์โทรศัพของคุณ'], '/assets/images/icon/icon-alert.svg'))
                .onResult().subscribe(
                    closed => console.log('closed', closed),
                    dismissed => console.log('dismissed', dismissed),
                    () => console.log('completed')
                );
            return;
        }

        let overCountResend = false;
        if (this.countdown() != '00:00' && this.countdown() != '') {
            this.logger.info(`${this.log_session_text} resendOTP countdown != 00:00`);
            //console.log('กรุณารอ', this.countdown, this.countResnedOTP)
            return;
        } else {
            this.countResnedOTP++;
        }

        if (this.countResnedOTP == 3) {
            this.logger.info(`${this.log_session_text} resendOTP countResendOTP == 3`);
            overCountResend = true;
            this.countResnedOTP = 0;
            this.generateOTPService.setCountdown(60 * 5);
        } else {
            //ขอ otp แล้ว setCountDown(60)
            this.logger.info(`${this.log_session_text} resendOTP countResendOTP !== 3`);

            if(this.mockUpStatus==false){
                this.logger.info(`${this.log_session_text} resendOTP generateOTP start`);
                this.generateOTP().subscribe();
                this.logger.info(`${this.log_session_text} resendOTP generateOTP end`);
            }else{
                this.logger.info(`${this.log_session_text} resendOTP otpRef:mockup`);
                this.otpRef.set("mockup")
            }
        }

        // Mockup resend OTP event
        if (overCountResend) {
            this.logger.info(`${this.log_session_text} resendOTP overCountResend alert error`);
            this.modalService
                .open(LineModalTemplateComponent, this.lineModalService.setModalConfig('alert', 'ขออภัย', ['คุณขอรหัส OTP เกินจำนวนครั้ง', 'ที่กำหนด กรุณาสมัครใหม่', 'กรุณาสมัครใหม่ ในอีก [setCountdown] นาที'], '/assets/images/icon/icon-alert.svg'))
                .onResult().subscribe(
                    closed => console.log('closed', closed),
                    dismissed => console.log('dismissed', dismissed),
                    () => console.log('completed')
                );
            this.otpLock = false;
        } else {
            //this.otpRef = this.otpRef.substring(0, this.otpRef.length - 1) + this.countResnedOTP;
            this.logger.info(`${this.log_session_text} resendOTP not overCountResend`);
            this.countOTP = 0;
            this.otpLock = false;
        }
    }

    generateOTP(): Observable<boolean> {
        return defer(() => {
        const funcName = 'generateOTP';
                this.logger.info(`${this.log_session_text} ${funcName} start`);
                const identity = this.lineStateAction.identityStateInfo;
                const channel = this.lineStateAction.channelStateInfo;

                const payload = {
                    phone_number: identity.phone_number,
                    electronic_channel: channel.electronic_channel
                };
                this.logger.info(`${this.log_session_text} ${funcName} marking payload start`);
                const log_payload = {
                    phone_number: this.getMaskingService.maskingData(identity.phone_number),
                    electronic_channel: channel.electronic_channel
                }
                this.logger.info(`${this.log_session_text} generateOTP start body:${JSON.stringify(log_payload)}`);
                const delete$: Observable<boolean> = this.otpToken ? this.deleteOTP(this.otpToken).pipe(
                    tap(() => this.logger.info(`${this.log_session_text} ${funcName} deleteOTP start`))
                ) : of(false)

                return delete$.pipe(
                    tap(() => {
                        this.ngOtpInputRef.setValue('') //เคลียค่า otpRef
                        this.logger.info(`${this.log_session_text} ${funcName} deleteOTP clear otpRef`);
                    }),
                    switchMap(() => this.otpService.generateOTP(payload)),
                    tap((res:any) => {
                        if (res['token']) {
                            this.logger.info(`${this.log_session_text} ${funcName} have token`);
                            this.otpRef.set(res['otpRef']);
                            this.otpToken = res['token']
                            this.otp = '';  //เคลียค่า otp 
                            this.invalidOTP.set(false); //ซ่อน validate error
                            this.generateOTPService.setCountdown(180);
                        } else {
                            this.logger.info(`${this.log_session_text} ${funcName} token is null`);
                        }
                    }),
                    map((res:any) => !!res['token']),
                    catchError((error:any) => {
                        this.logger.error(`${this.log_session_text} ${funcName} fatal error:${error?.message}`);
                        return of(false)
                    })
                )
    })
}

    deleteOTP(token:string): Observable<boolean> {
        const body = { token: token };
        return from(this.deleteOTPService.exec(body)).pipe(
            tap(() => this.logger.info(`${this.log_session_text} deleteOTP success`)),
            map(() => true),
            catchError(() => {
                this.logger.info(`${this.log_session_text} deleteOTP fail`)
                return of(false);
            })
        )
    }

    verifyOTP(token:string, otp:any) {
        let self = this;
        const body = { otpNumber: otp, token: token };
        const log_body = {
            otpNumber: this.getMaskingService.maskingData(otp),
            token: this.getMaskingService.maskingData(token)
        }
        this.logger.info(`${this.log_session_text} verifyOTP start body:${JSON.stringify(log_body)}`);
        return new Promise(function (resolve, reject) {
            self.verifyOTPService.exec(body).then((res: any) => {
                self.logger.info(`${self.log_session_text} verifyOTP response:${res?.response_desc}`);
                if (res.response_desc == 'Success') {
                self.logger.info(`${self.log_session_text} verifyOTP success`);
                    resolve({ status: true, msg: '' })
                } else if (res.response_desc == 'AuthenticationException$VerificationFailed') {
                    //รหัส OTP ไม่ถูกต้อง
                    self.logger.info(`${self.log_session_text} verifyOTP OTP Invalid`);
                    resolve({ status: false, msg: 'รหัส OTP ไม่ถูกต้อง' })
                } else if (res.response_desc == 'AuthenticationException$DeniedByPolicyMaxFailedAttemptsReached' || res.response_desc == 'Token is not in usable function state: status=Locked') {
                    //คุณกรอกรหัสไม่ถูกต้อง เกินจำนวนครั้งที่กำหนด กรุณากดขอรหัส OTP อีกครั้ง
                    self.logger.info(`${self.log_session_text} verifyOTP OTP Invalid and over max`);
                    resolve({ status: false, msg: 'คุณกรอกรหัสไม่ถูกต้อง เกินจำนวนครั้งที่กำหนด กรุณากดขอรหัส OTP อีกครั้ง' })
                } else if (res.response_desc == 'AuthenticationException$DeniedByPolicyTokenExpired') {
                    //รหัสของคุณหมดอายุ กรุณากดขอรหัส OTP อีกครั้ง
                    self.logger.info(`${self.log_session_text} verifyOTP OTP Expired AuthenticationException$DeniedByPolicyTokenExpired`);
                    resolve({ status: false, msg: 'รหัสของคุณหมดอายุ กรุณากดขอรหัส OTP อีกครั้ง' })
                } else if (res.response_desc == 'Missing required fields: otp, token_uuid') {
                    self.logger.info(`${self.log_session_text} verifyOTP OTP Expired Missing required fields: otp, token_uuid`);
                    resolve({ status: false, msg: 'รหัสของคุณหมดอายุ กรุณากดขอรหัส OTP อีกครั้ง' })
                } else {
                    self.logger.info(`${self.log_session_text} verifyOTP OTP fail`);
                    resolve({ status: false, msg: 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง' })
                }
            }).catch((error) => {
                self.logger.error(`${self.log_session_text} verifyOTP fail error:${error?.message}`);
                resolve({ status: false, msg: 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง' })
            })
        });
    }

    setButton(subchannel:string) {
        const text = this.btnSubmitGroup[subchannel];
        if (text) {
            this.btnSubmitText.set(text);
        }
    }

    // support short flow
    redirectToLineAdd() {
        const channel = this.lineStateAction.channelStateInfo;
        this.logger.info(`${this.log_session_text} redirectToLineAdd channel.subChannel:${channel?.subChannel}`);
        if (channel.subChannel == "6") {
            console.log("case OTP QR 6");
            const url = channel.oaMessageUrl;
            this.logger.info(`${this.log_session_text} redirectToLineAdd url:${url}`);
            console.log("url add friend: " + url);
            window.location.href = url;
        }
    }

    setSessionStorage(sessionRef:number) {
        const channel = this.lineActionService.channelStateInfo;
        const identity = this.lineStateAction.identityStateInfo;
        const customer = this.lineStateAction.customerStateInfo;
        const telemed = this.telemedStateActionService.lineInfo;
        const json = {
            "channel": channel,
            "identity": identity,
            "customer": customer,
            "telemed": telemed,
        }
        sessionStorage.setItem(sessionRef.toString(), JSON.stringify(json));
    }

    b64EncodeUnicode(str:string) {
        return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
            return String.fromCodePoint(Number.parseInt(p1, 16))
        }))
    }

    getPrimaryColor() {
        if (this.electronic_channel === 20) return 'rgb(130, 188, 0)'
      }
}
